export function exportBomData(
  bomData: unknown,
  filename = "bricksup-bom.json",
): void {
  const dataStr = JSON.stringify(bomData, null, 2);
  const dataUri =
    "data:application/json;charset=utf-8," + encodeURIComponent(dataStr);

  const linkElement = document.createElement("a");
  linkElement.setAttribute("href", dataUri);
  linkElement.setAttribute("download", filename);
  linkElement.click();
}
